import type { FC, Ref } from 'react'

import type { ObjectApplication } from '../../model/types'
import { ApplicationCard } from '../application-card'
import { ApplicationCardSkeleton } from '../application-card-skeleton'

import s from './styles.module.scss'

const APPLICATION_SKELETON_COUNT = 2

interface Props {
  applications: ObjectApplication[]
  paginationTargetRef: Ref<HTMLDivElement>
  shouldShowInitialLoader: boolean
  shouldShowPaginationLoader: boolean
  onApprove: (orderId: string) => void
  onReject: (orderId: string) => void
}

export const ApplicationsList: FC<Props> = ({
  applications,
  paginationTargetRef,
  shouldShowInitialLoader,
  shouldShowPaginationLoader,
  onApprove,
  onReject,
}) => {
  if (shouldShowInitialLoader) {
    return (
      <div
        className={s.list}
        aria-busy="true"
      >
        {Array.from(
          { length: APPLICATION_SKELETON_COUNT },
          (_, skeletonIndex) => (
            <ApplicationCardSkeleton key={skeletonIndex} />
          ),
        )}
      </div>
    )
  }

  return (
    <div className={s.list}>
      {applications.map((application) => (
        <ApplicationCard
          key={application.id}
          application={application}
          onApprove={() => onApprove(application.id)}
          onReject={() => onReject(application.id)}
        />
      ))}

      {shouldShowPaginationLoader ? <ApplicationCardSkeleton /> : null}

      <div
        ref={paginationTargetRef}
        className={s.paginationTarget}
      />
    </div>
  )
}
